module.exports = __webpack_public_path__ + "img/image2.95122981.jpg";